import { render } from "./HomeiconIphone.vue?vue&type=template&id=c68c4b0e&scoped=true"
import script from "./HomeiconIphone.vue?vue&type=script&lang=js"
export * from "./HomeiconIphone.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c68c4b0e"]])

export default __exports__